<template>
  <li role="presentation">
    <form
      class="b-dropdown-form"
      tabindex="-1"
    >
      <slot />
    </form>
  </li>
</template>

<script>
export default {
  name: 'BDropdownForm'
}
</script>
